import { palette } from './palette';

export const homeStyle = {
  /* Login -- Styles */
  '.login-root': {
    '& .section-header__title-wrapper':{
      '& .section-header__title':{
        fontSize: 40,
        fontFamily: 'Calibre',
      },
    },
    '& .hero-shaped__wrapper': {
      maxWidth: 'unset',
      '& .hero-shaped__left-side': {
        flex: '0 0 60%',
        maxWidth: '60%',

        '@media(min-width: 900px) and (max-width: 1200px)': {
          flex: '0 0 50%',
          maxWidth: '50%',
        },

        '& .hero-shaped__image': {
          width: '60vw',

          '@media(min-width: 900px) and (max-width: 1200px)': {
            width: '50vw',
          },
        },
      },
    },
  },

  '.header-wrapper': {
    background: `${palette.text.highlight} !important`,
    padding: '8px 16px',
    '& .MuiToolbar-root': {
      minHeight: '72px',
    },
  },

  '.puredentalspa-container': {
    marginTop: 88,
    '& .normal-text': {
      fontWeight: 300,
    },
    '& .hero-home-button': {
      backgroundColor: `${palette.surface.light} !important`,
      color: palette.text.primary,
      borderColor: palette.primary.main,

      '&:hover': {
        borderColor: palette.text.highlight,
      },
    },

    '& .savings-hero-section, .checkout-hero-section, .plan-selection-section,.faq-hero-section, .dashboard-hero-section, .find-provider-section, & .terms-hero-section, & .privacy-hero-section, & .hipaa-hero-section':
      {
        background: palette.secondary.main,
        color: palette.text.primary,
        marginTop: 88,

        '& h1,& h2,& h3,& h4,& p': {
          color: palette.text.primary,
        },
      },

    '& .subscription-wrapper, .addonsWrapper, .plan-selection-container': {
      '& .MuiSwitch-thumb': {
        background: palette.background.stepCounter,
      },
      '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
        backgroundColor: palette.background.main,
      },
      '& .MuiSwitch-track': {
        border: `1px solid ${palette.background.stepCounter}`,
        background: palette.background.main,
      },
    },

    /* App main - styles */
    '& .app-main-content': {
      paddingTop: 0,
    },

    /* Hero Section - Styles */
    '& .home-hero-wrapper': {
      background: palette.background.homeHeroWrapper,
      '& .hero-section-alternate': {
        height: 'auto !important',
        paddingBottom: 0,
      },
      '& .home-hero-title': {
        fontSize: 78,
        fontWeight:400,
        maxWidth: 600,
        color:palette.text.homeHeroTitle,
        fontFamily: 'Calibre',
        lineHeight: '64px',
        letterSpacing: '-1.44px',
      },
      '& .home-hero-subtitle': {
        fontSize: 18,
        maxWidth: 600,
        fontWeight: 400,
        color:palette.text.success,
      },
      '& .MuiButton-outlinedSecondary': {
        backgroundColor: palette.surface.light,
        borderColor: palette.primary.main,
        color: palette.primary.main,
      },
      '@media screen and (max-width: 900px)': {
        '& .home-hero-title': {
          fontSize: '2.5rem !important',
          // maxWidth: 'unset',
        },
        '& .section-header__cta-container': {
          width: '80vw',
        },
        '& .section-header__cta-item-wrapper': {
          display: 'flex',
          width: '100%',
          gap: '10px',
          '& .primary-button, .secondary-button': {
            flex: '1',
            minWidth: 0,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          },
        },
        '& .home-hero-subtitle': {
          fontSize: 16,
          fontFamily: 'Inter Display',
          maxWidth: 550,
        },
      },
      '@media(max-width: 900px)': {
        '& .section-alternate__content': {
          '& .image-wrapper': {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          },
          background: palette.surface.light,
        },
      },
    },

    /* Benefits - Styles */
    '& .definition-variant-4': {
      backgroundColor: palette.background.ribbon,
      '& .benefits-wrapper': {
        '& .section-header__title': {
          fontSize: '40px',
          textAlign: 'center',
        },
      },
      '& #definition-section': {
        '& .benefits-wrapper': {
          padding: '0 24px',
        },
      },
    },
    '& .definition-Wrapper': {
      backgroundColor: palette.background.ribbon,
      '& .section-header__title': {
        fontSize: 50,
        fontWeight: 400,
        fontFamily: 'Calibre',
      },
      '& .section-alternate__content': {
        padding: '48px 16px',

        '@media (min-width: 600px)': {
          padding: '48px',
        },
        '@media (min-width: 900px)': {
          padding: '72px 48px 80px',
        },
      },
      '& .benefits-wrapper': {
        '& .service-tile-wrapper': {
          '& .definition-service-tile': {
            '& .definition-desc-wrapper': {
              borderBottom: `1px solid ${palette.surface.border} !important`,
            },
          },
        },
          '@media(max-width: 1200px) and (min-width: 500px)': {
            padding: '0px 40px !important',
          },
          '@media(max-width: 500px)': {
            padding: '0px 16px !important',
          },
        },
      '& .definition-services-grid': {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        gap: 24,
        justifyContent: 'center',
        alignItems: 'stretch',

        '@media screen and (max-width: 900px)': {
          gridTemplateColumns: '1fr',
        },
      },
      '& .definition-services-grid': {
        paddingTop: '16px !important',
      },
      '& .MuiCardContent-root': {
        padding: 32,
        border: `1px solid ${palette.background.main}`,
      },
      
      '& .definition-service-header': {
        justifyContent: 'flex-end',
        flexDirection: 'row-reverse',
        marginBottom: 24,
      },
      '& .definition-service-title': {
        marginLeft: 16,
        fontWeight: 400,
        letterSpacing: '-0.32px',
      },
      '& .definition-service-description': {
        marginBottom: 0,
        textAlign: 'left',
      },
    },

    /* Pricing & Benefits / Subscription - Styles */
    '& .subscription-wrapper': {
      '& .subscription-bg': {
        height: '100%',
        background: `url('/images/home-images/section-pricing.webp') no-repeat`,
        
      },
      '& .section-header__title': {
        fontSize: 48,
        fontFamily: 'Calibre',
        fontWeight: 400,
      },
      '& .section-header__subtitle': {
        fontWeight: 400,
        fontSize: 18,
      },
      '& .section-header__title, .section-header__subtitle, .summary-text, .summary-subtext, .subscription-tabs-label':
        {
          color: `${palette.background.main} !important`,
        },
      '& .summary-text': {
        fontWeight: 400,
      },
      '& #pricing-benefit-section': {
        '& .planCard': {
          '&:hover': {
            border: `1px solid ${palette.primary.main}`,
            color: palette.text.primary,
            background: palette.text.highlight,
          },
          '& .highlight-divider': {
            backgroundColor: palette.text.disabled,
          },
          '& .MuiButton-outlinedSecondary': {
            backgroundColor: palette.surface.light,
            borderColor: palette.primary.main,
            color: palette.primary.main,
            '&:hover': {
              opacity: 1,
            },
          },
          '& .customcardTitle':{
            fontWeight: 400,
            fontSize: 24,
            color:palette.text.homeHeroTitle,
          },
        },
        '& .subscription-section': {
          objectFit: 'cover',
          '& .section-header': {
            maxWidth: 620,

            '@media(min-width: 900px)': {
              margin: '0px auto 32px',
            },
            '@media(max-width: 900px)': {
              margin: '0px auto 32px',
            },
          },
          '& .plans-loader': {
            color: palette.text.highlight,
          },
        },
        '& .savings-summary-link': {
          color: palette.background.main  ,
          textDecoration: 'underline',
          cursor: 'pointer',
        },
      },
    },

    /* How it works - Styles */
    '& .howitworks-section': {
      background: `${palette.background.default} !important`,
      '& .section-header__title': {
        fontSize: 48,
        fontFamily: 'Calibre',
        fontWeight: 400,
      },

      '& .howitworks-title': {
        marginBottom: 40,
      },

      '& .howitworks-wrapper': {
        padding: 20,
      },

      '& .howitworks-wrapper-left': {
        padding: 20,
      },

      '& .makeStyles-root-54': {
        padding: 0,
      },

      '& .how-cover-image': {
        backgroundSize: 'cover',
      },

      '& .step-counter': {
        borderRadius: '50%',
        backgroundColor: palette.background.stepCounter,
        color: palette.text.highlight,
        fontSize: 16,
      },

      '& .step-started-button': {
        '& .right-icon': {
          color: palette.text.highlight,
        },
      },

      '& .working-steps-container:not(:last-child)': {
        paddingBottom: 30,
      },

      '@media screen and (max-width: 1024px)': {
        '& .howitworks-wrapper-left': {
          padding: '5px',
        },
      },

      '@media(min-width: 1025px)': {
        '& .howitworks-wrapper-left': {
          paddingLeft: '40px',
        },
      },
    },

    /* Savings Summary */
    '& .savings-wrapper': {
      '& .savings-hero-section': {
        background: `url('/images/section-banner.webp') no-repeat`,
        backgroundSize: 'cover',
        '& .hero-header-title': {
          fontSize: 40,
          fontFamily: 'Calibre',
        },
      },
      '& .hero-home-button': {
        backgroundColor: `transparent !important`,
        color:`${palette.background.default} !important`,
        border:`1px solid ${palette.background.default} !important`,
      },
      '& .savingsDataContainer': {
        '& .footer-bar':{
          backgroundColor: palette.surface.savings,
        },
        '& .view-more-button':{
          backgroundColor: palette.primary.main,
          color: palette.text.highlight,
        }
      },
      '& .section-header': {
        '& .section-header__title-wrapper': {
          '& .hero-header-title':{
            color: palette.text.highlight,
          },
        },
        '& .section-header__subtitle-wrapper': {
          '& .hero-header-subtitle':{
            color: palette.text.highlight,
          },
        },
      },
      '& .select-location-grid': {
        width: '100%',
        maxWidth: 'unset',
        flexBasis: 'auto',
      },
      '& .service-procedure-table': {
        border: `1px solid ${palette.secondary.main} !important`,
        '& .savings-topheader': {
          backgroundColor: `${palette.text.alternate} !important`,
          color: `${palette.text.highlight} !important`,
        },

        '& .savings-header': {
          color: palette.text.primary,
        },

        '& .savings-subheader': {
          backgroundColor: palette.background.main,
          color: palette.text.primary,
          fontWeight: 600,
        },
      },

      '& .savings-contact-card': {
        padding: '0px 60px !important',
        backgroundColor: palette.surface.light,
        '& .contact-card-title ':{
          fontSize: 40,
          fontFamily: 'Calibre',
        }
      },

      '& .footer-bar': {
        backgroundColor: palette.background.ribbon,
      },
      '& .footer-bar-text': {
        color: palette.text.primary,
      },
    },

    /* Static hero banner */
    '& .home-static-hero-wrapper': {
      '& .hero-static-bg': {
        backgroundColor: palette.text.footerbg,
      },
      '& .section-header__title': {
        color: palette.text.alternate,
        fontFamily: 'Calibre',
        fontWeight: 400,
      },
      '& .section-header__subtitle': {
        color: palette.text.success,
      },
      '& .MuiButton-containedPrimary': {
        backgroundColor: palette.primary.main,
        borderColor: palette.surface.learnMore,
        color: palette.text.highlight,
      },
    },

    /* Book Appointment */
    '& .morning-image, & .noon-image, & .evening-image': {
      fill: `${palette.primary.main} !important`,
    },

    /* Create Subscriber - Checkout flow container */
    '& .checkout-flow-container': {
      '& .provider-details': {
        border: `1px solid ${palette.text.border}`,
      },
      '& .addon-bg': {
        background: palette.background.secondaryLight,
      },
      '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
        backgroundColor: palette.primary.light,
      },
      '& .MuiSwitch-track': {
        border: `1px solid ${palette.primary.main}`,
        background: palette.text.highlight,
      },
      '& .MuiSwitch-thumb': {
        background: palette.primary.main,
      },
    },

    /* Create Subscriber - Choose plan */
    '& .plan-selection-container': {
      '& .plans-wrapper': {
        '& .planCard': {
          border: `1px solid ${palette.text.primary}`,
          '&:hover': {
            color: palette.text.primary,
            background: palette.text.highlight,
          },
          '& .highlight-divider': {
            backgroundColor: palette.text.highlight,
          },
          '& .planCardDescription': {
            height: 'calc(100% - 24px)',
          },
        },
      },
    },

    /* FAQ */
    '& .faq-hero-section': {
      background: `url('/images/section-banner.webp') no-repeat center center`,
      backgroundSize: 'cover',
      '& .hero-link-button': {
        backgroundColor: `${palette.background.default} !important`,
        color:'#000000 !important',
      },
      '& .hero-home-button': {
        backgroundColor: `transparent !important`,
        color:`${palette.background.default} !important`,
        border:`1px solid ${palette.background.default} !important`,
      },
      '& .hero-header-title, .hero-header-subtitle': {
        color: palette.background.main,
        margin: '0',
        maxWidth: 'unset',
      },
      '& .hero-header-title': {
        fontSize: 40,
        fontFamily: 'Calibre',
      },
      '& .header-container': {
        margin: '0',
      },
      '@media screen and (max-width: 900px)': {
        '& .faq-hero-internal': {
          marginTop: '10px',
          padding: '64px 24px !important',
        },
      },
    },
    '& .faqInnerContainer': {
      '& .Mui-selected': {
        backgroundColor: palette.surface.grey,
        color: palette.text.primary,
      },
      '& .accordion__collapsable-text': {
        color: palette.text.secondary,
      },
    },
    '& .faq-contact-section': {
      background: palette.surface.grey,
      width: '100%',
      margin: 'unset',
      maxWidth: 'unset',
      '& .contact-card-title':{
        fontSize: 40,
        fontFamily: 'Calibre',
      },
      '& .contact-card-subtitle': {
        color: palette.text.secondary,
        fontSize: 20,
      },
      '& .provider-contact-details': {
        color: palette.text.secondary,
        fontSize: 16,
      },
      '& .contact-img-wrapper': {
        width: '64px',
        maxWidth: '64px',
      },
    },

    /* Create Subscriber - Checkout */
    '& .checkout-outer-container': {
      '& .payment-title-root': {
        marginTop: 0,
      },
      '& .promo-spinner': {
        backgroundColor: 'unset',
      },
      '& .termsText': {
        fontFamily: 'none',
        fontWeight: 'bold',
      },
    },

    /* Contact Card - FAQ, Success Page */
    '& .faq-contact-wrapper': {
      background: palette.background.footer,
    },
    '& .mail-link': {
      color: palette.text.primary,
    },

    /* Dashboard Page - Appointment Header */
    '& .MuiTableRow-root .MuiTableCell-head': {
      color: palette.text.highlight,
    },

    '& .footer-wrapper': {
      background: palette.background.footer,
    },

    /* Stepper - styles */
    '& .customStepperRoot': {
      // maxWidth: '898px',
      '& .MuiStepConnector-lineHorizontal': {
        borderColor: palette.background.header,
        color: palette.background.header,
      },
    },

    // Stepper Icon Styles - Completed vs Uncompleted
    '& .MuiStepIcon-root': {
      color: 'transparent', // Default: transparent background
      width: 32,
      height: 32,
      borderColor: palette.background.stepperCompleted, // Common border color for all states
      
      // Completed step - filled circle with checkmark
      '&.MuiStepIcon-completed': {
        fill: `${palette.background.stepperCompleted} !important`, // Filled background
        color: palette.text.highlight,
        '& .MuiSvgIcon-root': {
          color: palette.background.header,
        },
      },
      
      // Active step - filled circle with number
      '&.MuiStepIcon-active': {
        fill: `${palette.background.stepperCompleted} !important`, // Filled background
        color: palette.text.highlight,
        '& .MuiSvgIcon-root': {
          color: palette.background.header,
        },
        '& .MuiStepIcon-text': {
          fill: palette.text.highlight, // White text on filled background
        },
      },
      
      // Uncompleted step - empty circle with number
      '&:not(.MuiStepIcon-completed):not(.MuiStepIcon-active)': {
        fill: `${palette.background.main} !important`, // Filled background
        '& .MuiSvgIcon-root': {
          color: 'transparent',
        },
        '& .MuiStepIcon-text': {
          fill: palette.background.stepperCompleted, // Dark text on transparent background
        },
      },
    },

    // Stepper Label Styles
    '& .MuiStepLabel-label': {
      color: palette.text.primary,
      
      '&.MuiStepLabel-completed': {
        color: palette.text.primary,
        fontWeight: 500,
      },
      
      '&.MuiStepLabel-active': {
        color: palette.text.primary,
        fontWeight: 500,
      },
    },

    // Stepper Connector Line
    '& .MuiStepConnector-lineHorizontal': {
      borderColor: `${palette.background.stepperCompleted} !important`,
      borderTopWidth: 2,
    },

    // Stepper Container Style
    '& .stepperContainer': {
      '@media(max-width: 900px)': {
        display: 'none',
      }
    },

    '& .stepperItems': {
      marginTop: 24,
    },

    '& .footer-wrapper': {
      paddingInline: '20px !important',
      '@media(min-width: 900px)': {
        paddingInline: '60px !important',
      },
      backgroundColor: `${palette.text.alternate} !important`,
    }
  },
};
